const APP_DEVELOPER = false;

const BASE_URL_PRODUCTION = "https://api.mariomendez.uy/";
const BASE_URL_LOCAL = "http://localhost:8888/mario_mendez_api/";

export const Constants = {
  BASE_URL: APP_DEVELOPER ? BASE_URL_LOCAL : BASE_URL_PRODUCTION,
};

export const LABELS = {
  1: "Vendió",
  2: "Alquiló",
  3: "Reservó",
  4: "Alquilada",
  5: "Alquilado",
  6: "Vendido",
  7: "Vendida",
  8: "Reservada",
  9: "Reservado",
  10: "En negociación",
  11: "Comercializada",
};
